export enum CrudActionEnum {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  BULK_EDIT = 'bulkEdit',
}
